import { render, staticRenderFns } from "./groupChat.vue?vue&type=template&id=f60a6802&scoped=true"
import script from "./groupChat.vue?vue&type=script&lang=js"
export * from "./groupChat.vue?vue&type=script&lang=js"
import style0 from "./groupChat.vue?vue&type=style&index=0&id=f60a6802&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60a6802",
  null
  
)

export default component.exports